import * as React from 'react';
import { Children, type ReactElement, isValidElement, useEffect } from 'react'

import { useGlobalControlsApi } from '../GlobalControlsProvider.js'

import type { ToolbarProps } from './types.js'

export function Toolbar(props: ToolbarProps) {
  const { children, placement = 'bottom', story } = props

  const { registerControl } = useGlobalControlsApi()

  useEffect(() => {
    const elements = Children.toArray(children).filter(e => isValidElement(e)) as ReactElement[]
    if (elements.length === 0) return

    const removeControls = registerControl(placement, ...elements)

    return () => {
      removeControls()
    }
  }, [children, registerControl, placement])

  return <>{story}</>
}
